<template>
  <v-card flat class="ma-n2 pa-0 waterlevel-quality-popup" width="250">
    <v-btn id="popupPanelCloseButton" text class="popup-panel-close-button d-sm-none">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
    <v-container fluid pa-0 pa-4>
      <v-row class="ma-0 pa-0">
        <v-col cols="12" sm="12" md="12" class="ma-0 pa-0">
          <strong>{{ sensordata.name }}</strong>
        </v-col>
      </v-row>
      <v-row class="ma-0 pa-0">
        <v-col
          cols="12"
          sm="12"
          md="12"
          class="ma-0 pa-0"
        >{{ new Date(sensordata.lastupdatedatetime).toLocaleString() }}</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-2">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon>mdi-home</v-icon>
        </v-col>
        <v-col cols="10" sm="10" md="10" class="ma-0 pa-0">{{ sensordata.description }}</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: markerColor }">mdi-weather-sunset</v-icon>
        </v-col>
        <v-col
          cols="10"
          sm="10"
          md="10"
          class="ma-0 pa-0"
        >poziom aktualny: {{ sensordata.water_level }} cm</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon>mdi-weather-sunset</v-icon>
        </v-col>
        <v-col
          cols="10"
          sm="10"
          md="10"
          class="ma-0 pa-0"
        >próg ostrzegawczy: {{ sensordata.warning_level }} cm</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon>mdi-weather-sunset</v-icon>
        </v-col>
        <v-col
          cols="10"
          sm="10"
          md="10"
          class="ma-0 pa-0"
        >próg alarmowy {{ sensordata.alarm_level }} cm</v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn @click="close" text>Zamknij</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "WaterLevelPopupVue",
  data() {
    return {};
  },
  methods: {
    close() {
      document.querySelector(".leaflet-popup-close-button").click();
    }
  },
  props: {
    sensordata: { type: Object }
  },
  computed: {
    markerColor: function() {
      let gradesColors = ["#228b22", "#ffd700", "#ff0000"];
      let markerColor = gradesColors[0];
      if (this.sensordata) {
        if (this.sensordata.water_level > this.sensordata.warning_level)
          markerColor = gradesColors[1];
        if (this.sensordata.water_level > this.sensordata.alarm_level)
          markerColor = gradesColors[2];
      }

      return markerColor;
    }
  }
};
</script>
<style>
@media (min-width: 480px) {
  .waterlevel-quality-popup {
    width: 100%;
    margin: 0px;
  }
}

.leaflet-popup-close-button {
  background-color: #e60085 !important;
  color: #ffffff !important;
  position: fixed !important;
  right: 0px !important;
  min-width: 0px !important;
  width: 30px !important;
  height: 30px !important;
  border-radius: 0px !important;
  margin-right: 9px !important;
  margin-top: 15px !important;
  padding: 8px 0px 0px 0px !important;
  font-weight: normal !important;
}

.popup-panel-close-button {
  background-color: #e60085 !important;
  color: #ffffff !important;
  position: fixed !important;
  padding: 0px !important;
  right: 0px !important;
  min-width: 0px !important;
  width: 30px !important;
  height: 30px !important;
  border-radius: 0px !important;
  margin-right: 9px !important;
  margin-top: 15px !important;
}
</style>